import sgPopupMixin from '@/mixins/sg-popup.mixin'

export default {
	name: 'imgPopup',
	mixins: [sgPopupMixin],
	props: {
		imgUrl: {
			type: String,
			default: ''
		},
	},
	computed: {
		renderContent() {
			return [
				<img style="margin-bottom: 0.2rem" src={this.imgUrl} alt="" />,
				<div style="font-size:16px;height: 30px;line-height: 30px;" class="uc-btn blue" onClick={() => {
					this.showPopup = false
				}}>确认</div>
			]
		},
	},
}
